import HotelsFeaturedCities from './HotelsFeaturedCities'

export default HotelsFeaturedCities
